import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {Typography, Stack, Divider, TableContainer} from '@mui/material';
import {Modal} from '../../../../components/Modal';
import {renderAmount} from '../../../../util';

export function AociModal({ctaSummaryData, open, onClose}) {
  if (!ctaSummaryData) {
    return null;
  }

  const totalAmount = useMemo(() => {
    let total = 0;

    for (const data of ctaSummaryData) {
      total += data.beginning_balance_rate_difference_contribution;
      total += data.net_posting_rate_difference_contribution;
    }

    return total;
  }, [ctaSummaryData]);

  return (
    <Modal
      keepMounted={false}
      open={open}
      width={800}
      onClose={onClose}
      title="Accumulated other comprehensive loss"
    >
      <Divider color="#DFE6E3" />
      <Stack px={3} py={2}>
        <Typography sx={{color: '#687B7A'}}>
          Effect of exchange rate changes on cash
        </Typography>
      </Stack>
      <TableContainer>
        <table
          style={{
            borderCollapse: 'separate',
            borderSpacing: 0,
            fontSize: 12,
            padding: 16,
            paddingTop: 0,
          }}
        >
          <thead style={{position: 'sticky', top: 0, backgroundColor: 'white'}}>
            <tr>
              <th style={{textAlign: 'left', borderBottom: '1px solid black'}}>
                Financial Statement Line Item
              </th>
              <th style={{textAlign: 'right', borderBottom: '1px solid black'}}>
                Beginning Balance Rate Difference Contribution
              </th>
              <th style={{textAlign: 'right', borderBottom: '1px solid black'}}>
                Net Posting Rate Difference Contribution
              </th>
              <th style={{textAlign: 'right', borderBottom: '1px solid black'}}>
                Total CTA Contribution
              </th>
            </tr>
          </thead>
          <tbody>
            {ctaSummaryData.map((data) => (
              <tr key={data.pli_id}>
                <td style={{textAlign: 'left', padding: '4px 0'}}>
                  <Typography>
                    {data.pli_name.charAt(0).toUpperCase() +
                      data.pli_name.slice(1)}
                  </Typography>
                </td>
                <td style={{padding: '4px 0'}}>
                  <Typography textAlign="right">
                    {renderAmount(
                      data.beginning_balance_rate_difference_contribution
                    )}
                  </Typography>
                </td>
                <td style={{padding: '4px 0'}}>
                  <Typography textAlign="right">
                    {renderAmount(
                      data.net_posting_rate_difference_contribution
                    )}
                  </Typography>
                </td>
                <td style={{padding: '4px 0'}}>
                  <Typography textAlign="right">
                    {renderAmount(
                      data.beginning_balance_rate_difference_contribution +
                        data.net_posting_rate_difference_contribution
                    )}
                  </Typography>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={3} />
              <td
                style={{
                  borderBottom: '3px double black',
                  borderTop: '1px solid black',
                }}
              >
                <Typography align="right">
                  Total: {renderAmount(totalAmount)}
                </Typography>
              </td>
            </tr>
          </tfoot>
        </table>
      </TableContainer>
      <Typography sx={{color: '#687B7A'}} p={2}>
        This amount represents the total effect of exchange rate changes on cash
        and cash equivalents across all balance sheet lines items. This amount
        can be directly tied to the total on the CTA Audit Report in Netsuite
        for the period.
      </Typography>
    </Modal>
  );
}

AociModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  ctaSummaryData: PropTypes.any,
};
